/**
 * Uses fetch to get a JSON result from a URL
 * @param {Object} args all the arguments fetch accepts
 * @returns {Object} JSON returned from
 */

export const getJson = async (...args) => {
  const response = await fetch(...args);

  return await response.json();
};
